import axios from 'axios';
import { PaginatedMeasureTypes } from './types';

export const fetchMeasureTypes = async (): Promise<PaginatedMeasureTypes> => {
  return (await axios.get('/v1/measure-type')).data;
};
